import { axios, handleApiErrors, getToken } from '../helpers'

export default (property_id = null, product_id = null) => {
  const token = getToken()
  const params = { token }
  if (property_id) {
    params.property_id = property_id
  }
  if (product_id) {
    params.product_id = product_id
  }

  return axios
    .request({
      url: 'interactions/states2',
      params
    })
    .then(handleApiErrors)
}
